import { CustomElement, resolve } from 'aurelia';
import { UiService } from '../../services';
import template from './lightbox.html';
import './lightbox.css';

// Full-screen image viewer. Renders only when UiService holds a lightbox image; clicking
// anywhere dismisses it. State lives entirely in UiService so any component can open it.
export class LightboxElement {
  readonly ui: UiService = resolve(UiService);
}

export const Lightbox = CustomElement.define({
  name: 'lightbox',
  template
}, LightboxElement);
